// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.CancelRentAmountChangeWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { CancelRentAmountChangeWebApiRequestDto } from '../..';

export const CancelRentAmountChangeWebApiHandler_cancelRentAmountChange_Path = '/api/web/v1/cancelRentAmountChange';

/**
 * Cancel a rent amount change request for a landlord property
 */
export const CancelRentAmountChangeWebApiHandler_cancelRentAmountChange = (
  postData: CancelRentAmountChangeWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CancelRentAmountChangeWebApiRequestDto, void>(
    {
      endpoint: CancelRentAmountChangeWebApiHandler_cancelRentAmountChange_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
